import { IoIosMore } from "react-icons/io";
import FormatePrice from '../../utils/FormatePrice';
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/react";
import { useDispatch } from "react-redux";
import { fetchOrders } from "../../redux/slices/orderSlice";
import { useEffect } from "react";
import { OrderStatusMap, TransactionStatus } from "../../utils/Enums";
import ResponsivePagination from 'react-responsive-pagination';
import 'react-responsive-pagination/themes/classic.css';
import Loader from "../Loader";

const OrderTable = ({ onRowClick, data, itemsPerPage, currentPage, setCurrentPage, isLoading, totalRecord }) => {
  const dispatch = useDispatch();
  console.log(data)


  const totalPages = Math.ceil(totalRecord / itemsPerPage);

  useEffect(() =>{
      dispatch(fetchOrders())
  }, [dispatch]);
 

  return (
    <div className="flow-root bg-white">
        <div className="overflow-x-auto h-full rounded-lg ">
          <div className="inline-block min-w-full align-middle">
            <table className="min-w-full divide-y divide-gray-300 table-auto p-4 border">
              <thead className="bg-primaryGray p-1 rounded-t-md rounded-tr-md">
                <tr>
                  <th scope="col" className="py-3.5 pl-4 pr-3 text-left text-sm lg:text-md font-bold text-black">
                    S/N
                  </th>
                  <th scope="col" className="whitespace-nowrap py-3.5 pl-4 pr-3 text-left text-sm lg:text-md font-bold capitalize text-black">
                  Order ID
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm lg:text-md font-bold capitalize text-black">
                  customer name
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm lg:text-md font-bold capitalize text-black">
                  Amount
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm lg:text-md font-bold capitalize text-black">
                    Order Status
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-center text-sm lg:text-md font-bold capitalize text-black">
                    Delivery Agent
                  </th>
                  <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-sm lg:text-md font-bold capitalize text-black">
                  Payment Status
                  </th>
                  <th scope="col" className="px-3 py-3.5 text-left text-sm lg:text-md font-bold capitalize text-black">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <Loader />
                ): data && data.length > 0 ? (
                  data.map((order, index) => (
                  <tr key={index} className="border-b border-b-primaryGray hover:bg-[#F9F9F9] mt-2">
                    <td className="px-3 text-sm lg:text-md text-black capitalize font-medium">{index + 1 }</td>
                    <td className="whitespace-nowrap px-3 py-4 text-sm lg:text-md text-black flex items-center capitalize">{order.code}</td>
                    <td className="px-3 text-sm lg:text-md text-black capitalize font-medium">{order.customerName}</td>
                    <td className="px-3 text-sm lg:text-md capitalize font-semibold">{FormatePrice(order.amount)}</td>
                    <td 
                    className={`text-sm lg:text-md capitalize font-semibold text-center rounded-m inline-block w-[120px] whitespace-nowrap px-4 py-2 my-2 rounded-md cursor-pointer
                       ${
                      OrderStatusMap[order.orderStatus] === 'Delivered'
                      ? 'bg-[#008000] text-white'
                      : OrderStatusMap[order.orderStatus] === 'Pending'
                      ? 'bg-orange text-black'
                      : 'bg-[#4A90E2] text-white'
                      }   
                    `}
                      onClick={() => onRowClick(order.id)}
                    >
                      <span>{OrderStatusMap[order.orderStatus] || "Unknown Status"}</span>
                    </td>
                    <td className={`px-3 text-sm lg:text-md text-center capitalize font-medium
                      ${
                        order.agentName === "Unassigned" 
                        ? "text-primaryRed" : "text-black font-semibold"
                      }
                    `}>
                      {order.agentName}
                    </td>
                    <td className={`${TransactionStatus[order.paymentStatus] === "Failed" ? "bg-[#FFE6E6] text-[#FF0000] border border-[#FFB0B0]" : TransactionStatus[order.paymentStatus] === "Success" ? "bg-[#D9ECD9] text-[#B0D8B0] border-[#008000]" : TransactionStatus[order.paymentStatus] === "Initiated" ? "bg-[#F9F9F9] text-primaryGray border  border-primaryGray": "bg-[#FFEEAD] border  text-orange border border-orange"} capitalize font-semibold rounded-md inline-block w-[120px] text-sm text-center whitespace-nowrap px-3 py-2 my-2 rounde-md`}
                    >{TransactionStatus[order.paymentStatus] || "Unknown Status"}</td>
                    <td className="px-3 text-sm lg:text-md text-gray-500">
                    <Menu as="div" className="relative inline-block text-left">
                      <div>
                        <MenuButton className="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-transparent px-3 py-2 text-sm lg:text-md font-semibold text-[#B3B3B3] ring-0 hover:bg-gray-50">
                          <IoIosMore />
                        </MenuButton>
                      </div>
                      <MenuItems
                        transition
                        className="absolute right-0 z-50 mt-2 w-fit origin-top-right rounded-md bg-[#DADADA] shadow-lg ring-1 ring-black/5 transition focus:outline-none data-[closed]:scale-95 data-[closed]:transform data-[closed]:opacity-0 data-[enter]:duration-100 data-[leave]:duration-75 data-[enter]:ease-out data-[leave]:ease-in"
                      >
                        <div className="py-1">
                          <MenuItem>
                              <button
                                className="block w-full px-4 py-2 text-sm lg:text-md text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none text-left whitespace-nowrap">
                                  Assign delivery agent
                              </button>
                            </MenuItem>
                            <MenuItem>
                              <button
                                className="block w-full px-4 py-2 text-sm lg:text-md text-gray-700 data-[focus]:bg-gray-100 data-[focus]:text-gray-900 data-[focus]:outline-none  text-left whitespace-nowrap">
                                  Update status
                              </button>
                            </MenuItem>
                        </div>
                      </MenuItems>
                    </Menu>
                    </td>
                  </tr>
                )))
              : (
                <p className="text-sm text-primaryRed text-center py-4">No Order currently</p>
              )
              }
              </tbody>
            </table>
            <nav className="grid place-items-center mt-10">
            <ResponsivePagination
              current={currentPage}
              total={totalPages}
              onPageChange={setCurrentPage}
              extraClassName="custom-pagination"
            />
            </nav>
          </div>
        </div>
    </div>
  )
}

export default OrderTable